import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import RoundedButton from 'Components/ComponentLibrary/Atoms/Inputs/RoundedButton';
import BodyText from 'Components/ComponentLibrary/Atoms/Text/BodyText';
import Dialog from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Dialog';
import DialogContent from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/DialogTitle';
import DialogActions from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/DialogActions';
import AdvancedTypography from 'Components/UI/AdvancedTypography';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import TextButton from 'Components/ComponentLibrary/Components/Uncategorized/TextButton';
import {
  AuthenticationFactorActionModifyText,
} from 'Views/Page/Content/Templates/SettingsTemplate/Content/AuthenticationFactorTemplate/AuthenticationFactorsCard/AuthenticationFactorListPicker/AuthenticationFactorList/Content/AuthenticationFactorListItem/AuthenticationFactorListItemModifyActionPicker/AuthenticationFactorListItemModifyAction';

const styles = (theme) => ({
  root: {
  },
  dialog: {},
  dialogContent: {
    margin: theme.spacing(2, 0, 2, 0),
  },
  dialogActionsCentered: {
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'column',
  },
});

const AuthenticationFactorListItemContactAction = ({
  className,
  classes,
  authenticationFactorResource,
}) => {
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const [showModal, setShowModal] = React.useState(null);

  const handleUpdateAuthenticationFactor = (authenticationType) => {
    logStandardizedEvent(categories.userSettingsSecurity, eventTypes.clickButton, 'Authentication Type Modify: Show contact support message', {
      eventProperties: {
        authenticationType,
      },
    });
    setShowModal(authenticationType);
  };

  return (
    <>
      <Dialog
        className={classes.dialog}
        open={showModal}
        onClose={() => setShowModal(false)}
        title={'Unfortunately, we cannot process this request without verifying your identity.'}
      >
        <DialogContent className={classes.dialogContent}>
          <BodyText text={'Click below to contact our Client Support team who will work with you to update your security settings.'} />
        </DialogContent>
        <DialogActions className={classes.dialogActionsCentered}>
          <RoundedButton
            fullWidth
            onClick={() => {
              logStandardizedEvent(categories.userSettingsSecurity, eventTypes.clickButton, 'Authentication Type Modify: Open email to support', {
                eventProperties: {
                  authenticationType: authenticationFactorResource.attr('authenticationType'),
                },
              });
              window.open('mailto:support@facetwealth.com', '_blank');
              setShowModal(false);
            }}
          >{'Contact Support'}
          </RoundedButton>
          <br />
          <TextButton
            fullWidth
            onClick={() => setShowModal(false)}
          >
            {'Close'}
          </TextButton>
        </DialogActions>
      </Dialog>
      <AdvancedTypography
        className={classNames(classes.root, className)}
        fragments={
            [{
              color: 'secondary',
              onClick: () => handleUpdateAuthenticationFactor(authenticationFactorResource.attr('authenticationType')),
              text: AuthenticationFactorActionModifyText(authenticationFactorResource),
              underline: true,
              innerComponentProps: {
                test: `security-settings-${authenticationFactorResource.attr('authenticationType')}-modify-link`,
              },
            }]
        }
      />
    </>
  );
};

AuthenticationFactorListItemContactAction.defaultProps = {
  className: '',
};

AuthenticationFactorListItemContactAction.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  authenticationFactorResource: PropTypes.object.isRequired,
};

export default withStyles(styles)(AuthenticationFactorListItemContactAction);
